// Componente Toast - Notificación tipo toast
// Muestra notificaciones temporales en la esquina de la pantalla

import { useEffect } from 'react'
import './Toast.css'

/**
 * Componente Toast
 * @param {Object} props - Propiedades del componente
 * @param {boolean} props.isVisible - Si el toast está visible
 * @param {string} props.message - Mensaje a mostrar
 * @param {string} props.type - Tipo: 'success', 'error', 'warning', 'info'
 * @param {number} props.duration - Duración en milisegundos (0 = no auto-cerrar)
 * @param {Function} props.onClose - Función a ejecutar al cerrar
 */
function Toast({ isVisible, message, type = 'info', duration = 3000, onClose, actionLabel, onAction }) {
  useEffect(() => {
    if (isVisible && duration > 0) {
      const timer = setTimeout(() => {
        onClose()
      }, duration)

      return () => clearTimeout(timer)
    }
  }, [isVisible, duration, onClose])

  if (!isVisible) return null

  const icons = {
    success: '✓',
    error: '✕',
    warning: '⚠',
    info: 'ℹ'
  }

  const handleAction = (e) => {
    e.stopPropagation()
    if (onAction) onAction()
    onClose()
  }

  const handleClose = (e) => {
    e.stopPropagation()
    onClose()
  }

  const handleToastClick = () => {
    if (!onAction) return
    onAction()
    onClose()
  }

  const handleKeyDown = (e) => {
    if (!onAction) return
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      handleToastClick()
    }
  }

  return (
    <div
      className={`toast toast-${type} ${onAction ? 'toast-clickable' : ''}`}
      role="status"
      aria-live="polite"
      onClick={onAction ? handleToastClick : undefined}
      onKeyDown={onAction ? handleKeyDown : undefined}
      tabIndex={onAction ? 0 : undefined}
    >
      <div className="toast-content">
        <span className="toast-icon">{icons[type] || icons.info}</span>
        <span className="toast-message">{message}</span>
      </div>
      <div className="toast-actions">
        {actionLabel && onAction ? (
          <button className="toast-action" onClick={handleAction} type="button">
            {actionLabel}
          </button>
        ) : null}
        <button
          className="toast-close"
          onClick={handleClose}
          aria-label="Cerrar"
          type="button"
        >
          ✕
        </button>
      </div>
    </div>
  )
}

export default Toast

